import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableCell as MUITableCell,
  TablePagination,
  TableRow,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import MUITableHeadCell from "./../../components/TableHeadCell.js";

const TableCell = styled(MUITableCell)({
  overflowWrap: "anywhere",
  wordBreak: "normal"
});

const TableHeadCell = styled(MUITableHeadCell)({
  paddingTop: 6,
  paddingRight: 0,
  paddingBottom: 6,
  paddingLeft: 16,
});

const PublisherRow = ({ id, name, active, bidders_count, onEditClick }) => (
  <TableRow hover>
    <TableCell>{id}</TableCell>
    <TableCell>{name}</TableCell>
    <TableCell>{active ? "On" : "Off"}</TableCell>
    <TableCell>{bidders_count}</TableCell>
    <TableCell variant="body" align="right">
      <IconButton aria-label="edit" size="small" onClick={onEditClick(id)}>
        <EditOutlinedIcon />
      </IconButton>
    </TableCell>
  </TableRow>
);

const PublishersList = ({
  publishers,
  onSortOrderChange,
  onPageChange: handlePageChange,
  onRowsPerPageChange: handleRowsPerPageChange,
  page,
  rowsPerPage,
  totalCount,
  orderBy,
  orderDirection
}) => {
  const navigate = useNavigate();
  const onEditClick = (id) => () => navigate(`/programmatic_supply/publishers/${id}`);

  return (
    <Box
      style={{ style: "width: 100%" }}
      sx={{ boxShadow: "0 0 0 1px #E0E0E0", borderRadius: 1 }}
    >
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableHeadCell
                onSortOrderChange={onSortOrderChange}
                orderBy={orderBy}
                orderDirection={orderDirection}
                name="id"
                title="ID"
                align="left" />
              <TableHeadCell
                onSortOrderChange={onSortOrderChange}
                orderBy={orderBy}
                orderDirection={orderDirection}
                name="name"
                title="Publisher"
                align="left" />
              <TableHeadCell
                onSortOrderChange={onSortOrderChange}
                orderBy={orderBy}
                orderDirection={orderDirection}
                name="active"
                title="3P Programmatic Demand"
                align="left" />
              <TableHeadCell
                align="left"
                onSortOrderChange={onSortOrderChange}
                orderBy={orderBy}
                orderDirection={orderDirection}
                name="bidders_count"
                title="Total Bidders" />
              <MUITableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {publishers.map((config) => (
              <PublisherRow
                onEditClick={onEditClick}
                {...config}
                key={config.id}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        count={totalCount}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
        page={page}
        rowsPerPage={rowsPerPage}
        rowsPerPageOptions={[25, 50, 100]}
        SelectProps={{ native: true }}
      />
    </Box>
  );
};

export default PublishersList;
